import { black } from "../../StyleHelpers";
import { View } from "react-native";
import CardGridPlaylist from "../../components/CardGridPlaylist";
import AggregatePageLoader from "../../components/Loaders/AggregatePageLoader";
import { StyledContainerExtras } from "./styled";
import useGenericContentStore from "../../store/genericContent.store";

const Extras = (props: any) => {
	const isNarrow = useGenericContentStore((state: any) => state.isNarrow);

	return (
		<>
			{props.isExtrasLoading && props.gridSize ? (
				<StyledContainerExtras>
					<AggregatePageLoader isVam={true} slice={20} isExtras={true} />
				</StyledContainerExtras>
			) : (
				<View style={{ flex: 1, backgroundColor: black }}>
					{/* @ts-ignore */}
					<StyledContainerExtras isNarrow={isNarrow}>
						<CardGridPlaylist
							data={props?.data}
							hideTitle={true}
							isClips={true}
							isAssignToScreen={props.id === 1}
							parentProductId={props.parentProductId}
							isRedeem={props.redeem}
							isBorderClips={true}
							isExtras={true}
						/>

						{props.extraLoader && <AggregatePageLoader isVam={true} slice={props.gridSize} isExtras={true} />}
					</StyledContainerExtras>
				</View>
			)}
		</>
	);
};

export default Extras;
